/*
 * PC规则
 * 会诊中心 mdt
 * 患者招募 trial
 * 搜索 search
 * 专题 featrue
 * 专栏 column
 * 公开课 class
 * 文章 doc
 * 会诊专家 mdt/:id
 *
 * */
export default {
  "doc": "doc",
  "subjectList": "feature",
  "subject": "feature",
  "columnList": "column",
  "column": "column",
  "doctorPage": "mdt",
  "diagnosis": "mdt",
  "dgDoctorList": "mdt",
  "ClinicalRecruitment": "trial",
  "Index": "",
  "Search": "",
  "SearchResult": "",
  "LiveList": "class",
  "live": "class",
  "CaseList": "casestudy",
  "HotNews": "news",
}
